import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles, useTheme } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiAccordionSummary-content': {
            alignItems: 'end'
        }
    }
}));
const SimpleAccordion = ({ key, content, title }) => {
    const classes = useStyles();
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    return (
        <Accordion
            key={key}
            sx={{
                borderRadius: `${customization.borderRadius}px!important`,
                border: `3px solid ${theme.palette.primary.light} `
            }}
        >
            <AccordionSummary
                className={classes.root}
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-content${key}`}
                id={`panel-header${key}`}
            >
                {title}
            </AccordionSummary>
            <AccordionDetails>{content}</AccordionDetails>
        </Accordion>
    );
};

SimpleAccordion.propTypes = {
    key: PropTypes.string,
    content: PropTypes.element,
    title: PropTypes.element
};

export default SimpleAccordion;
